import API from './api';
import { AxiosResponse, CancelTokenSource } from 'axios';

const api = new API();

export const getAllTimezones: (cancelToken: CancelTokenSource) => Promise<AxiosResponse<string[]>> =
  (cancelToken) => {
    return api._get('/timezone', cancelToken);
  };
